module.exports = __webpack_public_path__ + "static/media/anthelios_information@3x.27e9cd8b.png";